var React = require('react');

function Copy (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"currentColor","d":"M19 5c1.105 0 2 .895 2 2v14c0 1.105-.895 2-2 2H8c-1.105 0-2-.895-2-2V7c0-1.105.895-2 2-2h11zm0 2H8v14h11V7zm-3-6v2H4v14H2V3c0-1.1.9-2 2-2h12z","key":0}),React.createElement("path",{"fillRule":"nonzero","d":"M0 0H24V24H0z","key":1})]));
}

Copy.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Copy;

Copy.default = Copy;
